import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ILookup } from '../shared/lookup';

// @Component({
//     // moduleId: module.id.toString(),
//     selector: 'production-contact',
//     templateUrl: 'production-contact.component.html'
// })
export abstract class ProjectItemComponent {
    
    @Input('group')
    public projectItemForm: FormGroup;
    @Input('count')
    public count: number;
    @Input('current')
    public current: number;
    @Input('lookup')
    public lookup: ILookup[];
    @Output() addItem = new EventEmitter()
    @Output() removeItem = new EventEmitter()


    addProjectItem() {
        this.addItem.next();
        return false;
    }

    removeProjectItem() {
        this.removeItem.next();
        return false;
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/project/project-item.component.ts